import { createActions } from "../../utils/reduxsauce";

const { Types, Creators } = createActions(
  {
    getSettings: { args: ["payload"], meta: { async: true } },
    getSettingWithId: { args: ["payload"], meta: { async: true } },
    editSetting: { args: ["payload"], meta: { async: true } },
    editAllSettings: { args: ["payload"], meta: { async: true } },

    showDialog: { args: [], meta: { async: false } },
    showDeleteDialog: { args: [], meta: { async: false } },
    resetDialog: { args: [], meta: { async: false } },
  },
  {
    prefix: "@app/settings/",
  },
);
export const ActionTypes = Types;
export default Creators;
